import { render, staticRenderFns } from "./contract_records.vue?vue&type=template&id=5965d1aa&scoped=true"
import script from "./contract_records.vue?vue&type=script&lang=js"
export * from "./contract_records.vue?vue&type=script&lang=js"
import style0 from "./contract_records.vue?vue&type=style&index=0&id=5965d1aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965d1aa",
  null
  
)

export default component.exports